/** @format */

import type {ChartConfiguration} from 'chart.js';

export interface MarkdownBlock {
  type: 'markdown';
  content: string;
}

export interface ChartBlock {
  type: 'chart';
  config: ChartConfiguration;
}

export type ContentBlock = MarkdownBlock | ChartBlock;

const CHART_BLOCK_REGEX = /```chart\n([\s\S]*?)```/g;

export const parseContent = (content: string): ContentBlock[] => {
  if (!content) {
    return [{type: 'markdown', content: ''}];
  }

  const blocks: ContentBlock[] = [];
  let lastIndex = 0;

  const matches = content.matchAll(CHART_BLOCK_REGEX);

  for (const match of matches) {
    const matchIndex = match.index ?? 0;

    if (matchIndex > lastIndex) {
      blocks.push({type: 'markdown', content: content.slice(lastIndex, matchIndex)});
    }

    try {
      const config = JSON.parse(match[1]) as ChartConfiguration;
      blocks.push({type: 'chart', config});
    } catch {
      blocks.push({type: 'markdown', content: match[0]});
    }

    lastIndex = matchIndex + match[0].length;
  }

  if (lastIndex < content.length) {
    blocks.push({type: 'markdown', content: content.slice(lastIndex)});
  }

  if (blocks.length === 0) {
    blocks.push({type: 'markdown', content});
  }

  return blocks;
};
